module.exports = __webpack_public_path__ + "9fb49e08503b356be778fc92b0709406.png";